export default '/build/fdf5c191.png'